const keyLabel = (obj : Object) => {
const arr = Object.keys(obj)
.filter(v => obj[v] != null)
.map(key => ({
  value: obj[key],
  label: obj[key],
 }))
  return arr;
}

export default keyLabel;